export default __webpack_public_path__ + "static/media/user.a2250eb7.svg";